<template>
    <web-modal id="onboarding-it">    
        <template slot="content">
            <figure>
                <img src="imgs/web/modal_onboarding_it.webp" srcset="imgs/web/modal_onboarding_it.webp 1x, imgs/web/modal_onboarding_it@2x.webp 2x" alt="">
            </figure>
            
            <strong class="new-headline-sm text-centered">Il primo passo verso l'app Vitadio</strong>

            <p class="new-text-md text-centered">Parlaci un po' di te per scoprire se Vitadio fa al caso tuo. Ti aiuteremo a ottenere l'accesso all'app.</p>
            
            <v-button
                modal-target="dismiss"
                position="center"
                label="Avanti"
            ></v-button>
        </template>
    </web-modal>
</template>

<script>
    export default {
        mounted() {
            $("#modal-onboarding-it").modal();
        },
    }
</script>
